import { create } from "zustand";
import produce from "immer";
import * as api from "../services/customers";
import { arrayToByIdsAllIds } from "./utils";

export const useCustomerStore = create((set) => ({
  byIds: {},
  allIds: [],
  total: 0,
  fetchSome: async ({ q = "", limit = 20, offset = 0 }) => {
    const some = await api.getSome({ q, limit, offset });
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;

        // TODO make pagination work if we keep all data
        //[draft.byIds, draft.allIds] = arrayToByIdsAllIds([...Object.values(draft.byIds), ...some.data]);
        //draft.total = some.total;
      }),
    );
    return some;
  },

  getById: async ({ id }) => {
    const one = await api.getById({ id });
    set(
      produce((draft) => {
        draft.byIds[one.data.id] = one.data;
        if (!draft.allIds.includes(one.data.id)) {
          draft.allIds.push(one.data.id);
        }
      }),
    );
  },

  updateOne: async ({ id, name, address, contact }) => {
    const one = await api.updateOne({
      id,
      name,
      address,
      contact,
    });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },

  assignCustomer: async ({ id, assigned_to_id }) => {
    const one = await api.assignCustomer({ id, assigned_to_id });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },
}));
